import Vue from 'vue';
import Vuex from 'vuex';
import { User } from '@/types';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {
      isLoggedIn: false,
      data: {} as User,
    },
  },

  getters: {
    user(state): User {
      return state.user.data;
    },
    isAdmin(state): boolean {
      const user = state.user.data;
      return user.role == 'admin' || user.email.endsWith('@filledstacks.com');
    },
    isCompany(state): boolean {
      const user = state.user.data;
      return user.role == 'company';
    },
    companyId(state): string | null {
      const user = state.user.data;
      return user.companyId ? user.companyId : null;
    },
  },

  mutations: {
    SET_LOGGED_IN(state, isLoggedIn: boolean) {
      state.user.isLoggedIn = isLoggedIn;
    },
    SET_USER(state, user: User) {
      state.user.data = user;
    },
  },

  actions: {
    setUser({ commit }, user: User) {
      console.log('setUser', user);
      commit('SET_LOGGED_IN', user !== null);
      if (user) {
        commit('SET_USER', user);
      } else {
        commit('SET_USER', null);
      }
    },
    logOut({ commit }) {
      commit('SET_LOGGED_IN', false);
    },
  },

  modules: {},
});
